import React, { useEffect, useRef, useState } from "react";
import { Button, Grid } from "@mui/material";
import Quill from "quill";
import "quill/dist/quill.snow.css";
import SoftBox from "components/SoftBox";
import PopUp from "./Component/PopUp";
import { useAppServices } from "hook/services";
import img_empty from "assets/images/img.jpg";
import { useUploadImage } from "hook/services";
import deleteIcon from "../../../../../assets/themeIcons/delete-icon.svg";
import editIcon from "../../../../../assets/themeIcons/edit-icon.svg";
import { uploadImageToGhl } from "hook/services";
import { useAgencyInfo } from "context/agency";
import toast from "react-hot-toast";
import SoftTypography from "components/SoftTypography";
import PrimaryButton from "../../../components/PrimaryButton";
import GhlMediaGallery from "components/GhlMediaGallery";
import { FaImages } from "react-icons/fa";
import "./accountDetailTabs.css";

function Blogs({ formData, handleRefresh }) {
  const AppService = useAppServices();
  const [success, setSuccess] = useState("");
  const [popup, setPopup] = useState(false);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [loading, setLoading] = useState(false);
  const quillRef = useRef(null);
  const quillInstance = useRef(null);
  const pasteCleanupRef = useRef(null);
  const uploadImage = useUploadImage();
  const [blogsData, setBlogsData] = useState([]);
  const [agency] = useAgencyInfo();
  const [imageUploading, setImageUploading] = useState(false);
  const [MainImage, setMainImage] = useState("");
  const [CoverImage, setCoverImage] = useState("");
  const [ghlGalleryOpen, setGhlGalleryOpen] = useState(false);
  const [ghlImageType, setGhlImageType] = useState("image");
  const [mainImageId, setmainImageId] = useState("");
  const [coverImageId, setCoverImageId] = useState("");

  const openGhlGallery = (type) => {
    setGhlImageType(type);
    setGhlGalleryOpen(true);
  };

  const handleGhlImageSelect = (pick) => {
    if (!pick?.url) return;
    if (ghlImageType === "image") {
      if (selectedBlog) {
        setSelectedBlog((prev) => ({ ...prev, image: pick?.url, image_id: pick?._id }));
      } else {
        setMainImage(pick?.url);
        setmainImageId(pick?._id);
      }
    } else if (ghlImageType === "cover_image") {
      if (selectedBlog) {
        setSelectedBlog((prev) => ({ ...prev, cover_image: pick?.url, cover_image_id: pick?._id }));
      } else {
        setCoverImage(pick?.url);
        setCoverImageId(pick?._id);
      }
    }
    toast.success("Image selected.");
  };

  const getBlogs = async () => {
    const { response } = await AppService.blogs.Get({
      query: `account_id=${formData._id}`,
    });
    if (response) {
      setBlogsData(response.data);
    }
  };

  useEffect(() => {
    if (popup) {
      setTimeout(() => {
        if (quillRef.current && !quillInstance.current) {
          quillInstance.current = new Quill(quillRef.current, {
            theme: "snow",
          });

          // Paste handler: upload pasted images to server and insert URL instead of base64
          const editorEl = quillRef.current?.querySelector?.(".ql-editor") || quillRef.current;
          if (editorEl) {
            const dataUrlToFile = (dataUrl) => {
              const arr = dataUrl.split(",");
              const mime = (arr[0].match(/:(.*?);/) || [])[1] || "image/png";
              const bstr = atob(arr[1]);
              let n = bstr.length;
              const u8 = new Uint8Array(n);
              while (n--) u8[n] = bstr.charCodeAt(n);
              return new File([u8], "pasted-image.png", { type: mime });
            };
            const MAX_DIM = 1200;
            const MAX_FILE_BYTES = 3 * 1024 * 1024;
            const resizeImageFile = (file) =>
              new Promise((resolve) => {
                if (!file.type.startsWith("image/")) {
                  resolve(file);
                  return;
                }
                const img = new Image();
                const url = URL.createObjectURL(file);
                img.onload = () => {
                  URL.revokeObjectURL(url);
                  let w = img.naturalWidth;
                  let h = img.naturalHeight;
                  if (w <= MAX_DIM && h <= MAX_DIM && file.size <= MAX_FILE_BYTES) {
                    resolve(file);
                    return;
                  }
                  if (w > MAX_DIM || h > MAX_DIM) {
                    if (w > h) {
                      h = Math.round((h * MAX_DIM) / w);
                      w = MAX_DIM;
                    } else {
                      w = Math.round((w * MAX_DIM) / h);
                      h = MAX_DIM;
                    }
                  }
                  const canvas = document.createElement("canvas");
                  canvas.width = w;
                  canvas.height = h;
                  const ctx = canvas.getContext("2d");
                  ctx.drawImage(img, 0, 0, w, h);
                  canvas.toBlob(
                    (blob) => {
                      if (blob) resolve(new File([blob], "pasted-image.jpg", { type: "image/jpeg" }));
                      else resolve(file);
                    },
                    "image/jpeg",
                    0.85
                  );
                };
                img.onerror = () => {
                  URL.revokeObjectURL(url);
                  resolve(file);
                };
                img.src = url;
              });
            const handlePaste = async (e) => {
              if (!agency) return;
              const range = quillInstance.current.getSelection(true) || { index: quillInstance.current.getLength() };
              let file = null;
              const items = e.clipboardData?.items;
              if (items) {
                for (const item of items) {
                  if (item.type.indexOf("image") !== 0) continue;
                  e.preventDefault();
                  e.stopPropagation();
                  file = item.getAsFile();
                  break;
                }
              }
              if (!file) {
                const html = e.clipboardData?.getData?.("text/html");
                const dataUrlMatch = html?.match(/src=["']?(data:image\/[^"'\s>]+)/i);
                const dataUrl = dataUrlMatch?.[1];
                if (dataUrl) {
                  e.preventDefault();
                  e.stopPropagation();
                  try {
                    file = dataUrlToFile(dataUrl);
                  } catch (_) {}
                }
              }
              if (!file) return;
              setImageUploading(true);
              try {
                const fileToUpload = await resizeImageFile(file);
                const imageResponse = await uploadImageToGhl(fileToUpload, agency);
                if (imageResponse?.data) {
                  quillInstance.current.insertEmbed(range.index, "image", imageResponse.data);
                  quillInstance.current.setSelection(range.index + 1);
                }
              } catch (err) {
                // upload failed
              } finally {
                setImageUploading(false);
              }
            };
            editorEl.addEventListener("paste", handlePaste, true);
            pasteCleanupRef.current = () => editorEl.removeEventListener("paste", handlePaste, true);
          }
        }
        if (selectedBlog && quillInstance.current) {
          quillInstance.current.root.innerHTML = selectedBlog.description || "";
        }
      }, 100);
    }
    return () => {
      pasteCleanupRef.current?.();
      pasteCleanupRef.current = null;
      if (!popup && quillInstance.current) {
        quillInstance.current = null;
      }
    };
  }, [popup, selectedBlog, agency]);

  const openPopup = () => setPopup(true);

  const closePopup = () => {
    setPopup(false);
    setSelectedBlog(null);
    quillInstance.current = null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const description = quillInstance.current ? quillInstance.current.root.innerHTML.trim() : "";

    const payload = {
      title: e.target?.title?.value,
      image: MainImage || selectedBlog?.image || "",
      image_id: mainImageId || selectedBlog?.image_id || "",
      cover_image: CoverImage || selectedBlog?.cover_image || "",
      cover_image_id: coverImageId || selectedBlog?.cover_image_id || "",
      description,
      date: new Date().toISOString(),
      account_id: formData?._id,
      agency_id: formData?.agency_id,
    };

    let response;

    if (selectedBlog) {
      response = await AppService.blogs.Update({
        payload: { ...payload, _id: selectedBlog._id },
      });
    } else {
      response = await AppService.blogs.Create({ payload });
    }

    if (response) {
      handleRefresh();
      setPopup(false);
      setSelectedBlog(null);
      getBlogs();
      toast.success(selectedBlog ? "Blog updated successfully!" : "New blog created successfully!");
    } else {
      toast.error("Error updating Data");
    }

    setLoading(false);
  };

  const deleteBlog = async (blog) => {
    const { response } = await AppService.blogs.Delete({
      query: `_id=${blog._id}`,
    });

    if (response) {
      handleRefresh();
      getBlogs();
      toast.success("Delete Successfully");
    } else {
      toast.error("Error deleting attachment");
    }
  };

  const editBlog = (blog) => {
    setSelectedBlog(blog);
    if (quillInstance.current) {
      quillInstance.current.root.innerHTML = blog.description || "";
    }
    openPopup();
  };

  useEffect(() => {
    getBlogs();
  }, [formData]);

  return (
    <div className="sd-account-detail-tab">
      <div style={{ display: "flex", justifyContent: "end", margin: "0 10px" }}>
        <PrimaryButton showPlus onClick={openPopup}>
          Add Blog
        </PrimaryButton>
      </div>

      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {blogsData?.map((blog, index) => (
          <SoftBox
            key={index}
            style={{
              margin: "10px",
              width: "30%",
              borderRadius: "10px",
              border: "1px solid #f5f5f5",
              padding: "10px",
            }}
          >
            <img
              src={blog.image || img_empty}
              alt={blog.title}
              style={{
                width: "100%",
                height: "200px",
                objectFit: "cover",
                borderRadius: "8px"
              }}
            />
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
              <h4 style={{ margin: 0 }}>{blog.title}</h4>
              <div style={{ display: "flex", gap: "10px" }}>
                <Button
                  variant="contained"
                  color="white"
                  onClick={() => editBlog(blog)}
                  style={{ minWidth: "auto", padding: "8px" }}
                >
                  <img src={editIcon} width={20} style={{ cursor: "pointer" }} alt="Edit" />
                </Button>
                <Button
                  variant="contained"
                  color="white"
                  style={{
                    background: "#e44d36",
                    color: "#fff",
                    minWidth: "auto",
                    padding: "8px"
                  }}
                  onClick={() => deleteBlog(blog)}
                >
                  <img src={deleteIcon} width={20} style={{ cursor: "pointer" }} alt="Delete" />
                </Button>
              </div>
            </div>
          </SoftBox>
        ))}
      </div>

      <PopUp open={popup} handleClose={closePopup} title={selectedBlog ? "Edit Blog" : "New Blog"}>
        <form onSubmit={handleSubmit}>
          <div>
            <div style={{ display: "flex", width: "100%" }}>
              <div style={{ width: "50%", padding: "10px" }}>
                <SoftBox>
                  <label className="text-black">Title</label>
                  <input
                    className="form-control-agust"
                    name="title"
                    type="text"
                    placeholder="Title"
                    defaultValue={selectedBlog?.title || ""}
                    required
                  />
                </SoftBox>
              </div>
              <div style={{ width: "50%", padding: "10px" }}>
                <SoftBox>
                  <label className="text-black">Image</label>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "6px" }}>
                    <button
                      type="button"
                      onClick={() => openGhlGallery("image")}
                      title="Choose from Media"
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
                        color: "white",
                        border: "none",
                        padding: "10px 18px",
                        borderRadius: "10px",
                        cursor: "pointer",
                        fontSize: "13px",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                        boxShadow: "0 2px 6px rgba(25, 118, 210, 0.35)",
                      }}
                    >
                      <FaImages size={16} />
                      {(selectedBlog?.image || MainImage) ? "Change Image" : "Select from Media"}
                    </button>
                    {(selectedBlog?.image || MainImage) && (
                      <img
                        src={selectedBlog?.image || MainImage}
                        alt="Blog"
                        style={{
                          width: "72px",
                          height: "72px",
                          objectFit: "cover",
                          borderRadius: "8px",
                          border: "1px solid #e2e8f0",
                        }}
                      />
                    )}
                  </div>
                </SoftBox>
              </div>
            </div>
            <div style={{ display: "flex", width: "100%" }}>
              <div style={{ width: "50%", padding: "10px" }}>
                <SoftBox>
                  <label className="text-black">Cover Image</label>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "6px" }}>
                    <button
                      type="button"
                      onClick={() => openGhlGallery("cover_image")}
                      title="Choose from Media"
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
                        color: "white",
                        border: "none",
                        padding: "10px 18px",
                        borderRadius: "10px",
                        cursor: "pointer",
                        fontSize: "13px",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                        boxShadow: "0 2px 6px rgba(25, 118, 210, 0.35)",
                      }}
                    >
                      <FaImages size={16} />
                      {(selectedBlog?.cover_image || CoverImage) ? "Change Cover" : "Select from Media"}
                    </button>
                    {(selectedBlog?.cover_image || CoverImage) && (
                      <img
                        src={selectedBlog?.cover_image || CoverImage}
                        alt="Cover"
                        style={{
                          width: "120px",
                          height: "48px",
                          objectFit: "cover",
                          borderRadius: "8px",
                          border: "1px solid #e2e8f0",
                        }}
                      />
                    )}
                  </div>
                  <Grid item xs={12} display={"flex"} alignItems="center" style={{ padding: 0 }}>
                    <SoftTypography
                      variant="p"
                      className="roboto-family"
                      style={{ fontSize: "13px", marginTop: "8px", color: "#64748b" }}
                    >
                      1MB maximum size. 5:2 ratio. Recommended dimensions: 1752 x 716 pixels.
                    </SoftTypography>
                  </Grid>
                </SoftBox>
              </div>
            </div>
            <div style={{ padding: "10px" }}>
              <SoftBox>
                <label className="text-black">Description</label>
                <div ref={quillRef} className="sd-account-detail-tab__quill" style={{ height: "250px", marginBottom: "20px" }} />
              </SoftBox>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              margin: "0 10px",
            }}
          >
            <PrimaryButton type="submit" disabled={loading}>
              {loading ? "Processing..." : selectedBlog ? "Update Blog" : "Save Blog"}
            </PrimaryButton>
          </div>
        </form>
      </PopUp>

      <GhlMediaGallery
        open={ghlGalleryOpen}
        onClose={() => setGhlGalleryOpen(false)}
        onSelect={handleGhlImageSelect}
        title={`Select ${ghlImageType === "cover_image" ? "Cover" : "Blog"} Image`}
        enableCrop
        cropAspectRatio={ghlImageType === "image" ? 1 / 1 : 7 / 2}
      />
    </div>
  );
}

export default Blogs;